// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2K9qi","name":"styles_name__O__aC","phone":"styles_phone__2qUHn"};